import React from 'react';

export default function Welcome({ onGetStarted }) {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(135deg, var(--page-bg) 0%, var(--brand-accent-light) 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '20px',
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        padding: '48px',
        maxWidth: '600px',
        width: '100%',
        textAlign: 'center',
      }}>
        {/* Logo */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '16px',
          marginBottom: '32px',
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            background: 'var(--brand-primary-light)',
            borderRadius: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '28px',
          }}>
            <img src="/logo192.png" alt="Logo" style={{ width: '48px', height: '48px', borderRadius: '8px' }} />
          </div>
          <span style={{
            fontWeight: '700',
            fontSize: '32px',
            color: 'var(--teal)',
            letterSpacing: '-0.5px',
          }}>
            Reaxano
          </span>
        </div>

        {/* Main Heading */}
        <h1 style={{
          fontSize: '28px',
          fontWeight: '700',
          color: 'var(--teal-dark)',
          marginBottom: '16px',
          lineHeight: '1.3',
        }}>
          Pilot cancer patient support for Ontario
        </h1>

        <p style={{
          fontSize: '18px',
          color: '#666',
          marginBottom: '32px',
          lineHeight: '1.5',
        }}>
          Track symptoms, medications, equipment lending, clinical trials, and patient resources in a pilot app for Kingston and Belleville. This is a demo today, with plans to expand into a unified cancer patient platform across Canada and evolve the experience as devices become available.
        </p>

        {/* Key Features */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
          gap: '24px',
          marginBottom: '40px',
          textAlign: 'left',
        }}>
          <div style={{
            padding: '20px',
            background: '#f8f9fa',
            borderRadius: '12px',
            border: '1px solid #e9ecef',
          }}>
            <div style={{
              fontSize: '24px',
              marginBottom: '12px',
            }}>🩺</div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '8px',
            }}>
              Symptom Tracker
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.4',
            }}>
              Record and review symptoms over time so patients and care teams can stay informed.
            </p>
          </div>

          <div style={{
            padding: '20px',
            background: '#f8f9fa',
            borderRadius: '12px',
            border: '1px solid #e9ecef',
          }}>
            <div style={{
              fontSize: '24px',
              marginBottom: '12px',
            }}>💊</div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '8px',
            }}>
              Medication Management
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.4',
            }}>
              Keep medication schedules, dosages, and treatment history organized in one place.
            </p>
          </div>

          <div style={{
            padding: '20px',
            background: '#f8f9fa',
            borderRadius: '12px',
            border: '1px solid #e9ecef',
          }}>
            <div style={{
              fontSize: '24px',
              marginBottom: '12px',
            }}>🧰</div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '8px',
            }}>
              Equipment Lending
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.4',
            }}>
              Support borrowing and tracking of exposure equipment as part of the pilot service.
            </p>
          </div>

          <div style={{
            padding: '20px',
            background: '#f8f9fa',
            borderRadius: '12px',
            border: '1px solid #e9ecef',
          }}>
            <div style={{
              fontSize: '24px',
              marginBottom: '12px',
            }}>🧪</div>
            <h3 style={{
              fontSize: '16px',
              fontWeight: '600',
              color: '#1a1a1a',
              marginBottom: '8px',
            }}>
              Clinical Trials & Resources
            </h3>
            <p style={{
              fontSize: '14px',
              color: '#666',
              lineHeight: '1.4',
            }}>
              Find relevant trials and patient resources while we continue building more features.
            </p>
          </div>
        </div>

        {/* Call to Action */}
        <button
          onClick={onGetStarted}
          style={{
            background: 'var(--teal)',
            color: 'white',
            border: 'none',
            borderRadius: '12px',
            padding: '16px 32px',
            fontSize: '18px',
            fontWeight: '600',
            cursor: 'pointer',
            boxShadow: '0 4px 12px rgba(26, 39, 99, 0.24)',
            transition: 'all 0.2s ease',
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 16px rgba(18, 27, 73, 0.32)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 12px rgba(26, 39, 99, 0.24)';
          }}
        >
          Get Started
        </button>

        {/* Contact & Footer */}
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '10px',
          marginTop: '24px',
          color: '#4b5563',
          fontSize: '14px',
          lineHeight: '1.5',
          textAlign: 'center',
        }}>
          <div>
            Support: <a href="mailto:reaxano@gmail.com" style={{ color: '#0f766e', textDecoration: 'underline' }}>reaxano@gmail.com</a>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', gap: '12px', flexWrap: 'wrap' }}>
            <a
              href="https://www.facebook.com/share/1Hua67K3eA/?mibextid=wwXIfr"
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 16px',
                borderRadius: '999px',
                border: '1px solid #d1d5db',
                background: 'white',
                color: '#2563eb',
                textDecoration: 'none',
                fontWeight: '700',
              }}
            >
              Facebook
            </a>
            <a
              href="https://www.instagram.com/reaxano.app?igsh=NmV3NzlmdWMycmFn&utm_source=qr"
              target="_blank"
              rel="noreferrer"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '10px 16px',
                borderRadius: '999px',
                border: '1px solid #d1d5db',
                background: 'white',
                color: '#d14772',
                textDecoration: 'none',
                fontWeight: '700',
              }}
            >
              Instagram
            </a>
          </div>
          <div>
            This pilot is a demo for Kingston and Belleville, with future plans to evolve into a unified cancer patient app across Canada as devices and services are added.
            Always consult your healthcare provider for medical concerns.
          </div>
        </div>
      </div>
    </div>
  );
}
